import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSidebar } from '../context/SidebarContext';
import { ChangePasswordModal } from './ChangePasswordModal';
import { canAccessUsersPage } from '../utils/familyTreeHelper';
import '../styles/sidebar.scss';

export const Sidebar: React.FC = () => {
  const { user, logout } = useAuth();
  const { isOpen, closeSidebar } = useSidebar();
  const location = useLocation();
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  const handleNavClick = () => {
    // Close sidebar on mobile when navigating
    closeSidebar();
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}
      <div className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <h2>
            <i className="fas fa-tree"></i> Gia phả
          </h2>
          <button className="sidebar-close" onClick={closeSidebar} aria-label="Close sidebar">
            <i className="fas fa-times"></i>
          </button>
        </div>

        <ul className="sidebar-nav">
          <li>
            <Link
              to="/family-tree"
              className={isActive('/family-tree') ? 'active' : ''}
              onClick={handleNavClick}
            >
              <i className="fas fa-sitemap"></i>
              <span>Cây phả hệ</span>
            </Link>
          </li>
          <li>
            <Link
              to="/profile"
              className={isActive('/profile') ? 'active' : ''}
              onClick={handleNavClick}
            >
              <i className="fas fa-user-circle"></i>
              <span>Thông tin cá nhân</span>
            </Link>
          </li>
          {user?.isAdmin && (
            <>
              <li>
                <Link
                  to="/family-names"
                  className={isActive('/family-names') ? 'active' : ''}
                  onClick={handleNavClick}
                >
                  <i className="fas fa-book"></i>
                  <span>Dòng họ</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/data-import-export"
                  className={isActive('/data-import-export') ? 'active' : ''}
                  onClick={handleNavClick}
                >
                  <i className="fas fa-file-import"></i>
                  <span>Export/Import</span>
                </Link>
              </li>
            </>
          )}
          {canAccessUsersPage(user) && (
          <li>
            <Link
              to="/users"
              className={isActive('/users') ? 'active' : ''}
              onClick={handleNavClick}
            >
              <i className="fas fa-users"></i>
              <span>Người dùng</span>
            </Link>
          </li>
          )}
        </ul>

        <div className="sidebar-footer">
          {user && (
            <>
              <div className="user-info">
                <p>
                  <strong>Người dùng:</strong>
                </p>
                <p>{user.fullName}</p>
                <p style={{ fontSize: '12px', color: '#bdc3c7' }}>
                  {user.email}
                </p>
                {user.isAdmin && (
                  <p style={{ fontSize: '12px', color: '#f39c12' }}>
                    <i className="fas fa-shield-alt"></i> Admin
                  </p>
                )}
              </div>
              <button
                className="logout-btn"
                onClick={() => setIsPasswordModalOpen(true)}
                style={{ marginBottom: '8px' }}
              >
                <i className="fas fa-key"></i> Đổi mật khẩu
              </button>
              <button
                className="logout-btn"
                onClick={logout}
              >
                <i className="fas fa-sign-out-alt"></i> Đăng xuất
              </button>
              {user && (
                <ChangePasswordModal
                  isOpen={isPasswordModalOpen}
                  onClose={() => setIsPasswordModalOpen(false)}
                  userId={user.id}
                />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
